<template>
  <modal :state="state" :index="index" @toggle-modal="reset" :should-cancel-on="state.status !== ModalStatus.InProgress">
    <div class="organization-modal" :slot="ModalStatus.Confirmation">
      <h3 class="modal-title">Join Organization</h3>
      <p class="sub-title">Type in the name of the organization you wish to join.</p>

      <div>
        <div class="sr-only">
          <label for="organization-subdomain">Subdomain</label>
        </div>
        <row class="component-row">
          <column>
            <input id="organization-subdomain" class="align-right" type="text" v-model="subdomain" @keydown.enter="joinOrg">
          </column>
          <suffix>
            <pencil color="Inherit">.Formability.com</pencil>
          </suffix>
        </row>
      </div>

      <div class="cta">
        <button type="button" class="btn red outline block" data-dismiss="modal" @click="reset">Cancel</button>
        <button type="button" class="btn green block"
                @click="joinOrg"
                :disabled="!isValidOrganization">
          Next
        </button>
      </div>
    </div>

    <div :slot="ModalStatus.Successful">
      <h3 class="modal-title">Success!</h3>
      <p>You have successfully requested to join this organization. We will notify you about the status of your request on your personal dashboard.</p>
      <div class="cta">
        <button @click="goHome" type="button" class="btn green">Personal Dashboard</button>
      </div>
    </div>

    <div :slot="ModalStatus.InProgress">
      <h3 class="modal-title">Requesting to join {{orgHost}}...</h3>
      <p>This will take just a second.</p>
    </div>

    <div :slot="ModalStatus.Failure">
      <h3 class="modal-title">Join Organization</h3>

      <flash-attribute-messages v-if="errors" :messages="errorsList"></flash-attribute-messages>

      <div class="cta">
        <button @click="reset" type="button" class="btn green">Continue</button>
      </div>
    </div>
  </modal>
</template>

<script lang="ts">
  import Vue from "vue";
  import {RegexHelper} from "../../../helpers/regexHelper";
  import Join from "../../../models/appRequests/organizations/join";
  import Selected from "../../../state/modules/selected";
  import FlashAttributeMessages from "../../flash/flash-attribute-messages.vue";

  const MESSAGES = {
    403: 'You are not authorized to join this organization.',
    404: 'Organization not found.',
    500: 'Could not join the organization. Please try again later.',
  };

  export default Vue.extend({
    components: {FlashAttributeMessages},
    props: {
      state: Object,
    },
    data: function () {
      return {
        subdomain: '',
        errors: null,
      }
    },
    computed: {
      isValidOrganization(): boolean {
        return RegexHelper.isValidSubdomain(this.subdomain);
      },
      errorsList(): string[] {
        return Array.isArray(this.errors) ? this.errors : [this.errors];
      },
      orgHost(): string {
        return `${this.subdomain}.${window.AppConfig.host}`;
      }
    },
    methods: {
      joinOrg(): void {
        if (this.isValidOrganization) {
          this.state.status = this.ModalStatus.InProgress;
          let join = new Join();
          join.organization_subdomain = this.subdomain;
          join.requester_id = Selected.currentUser.get().id;
          join.save().then(([data]) => {
            if (data.success) {
              this.state.status = this.ModalStatus.Successful;
              this.errors = null;
            } else {
              this.state.status = this.ModalStatus.Failure;
              if (data.errors && data.errors.join) {
                this.errors = data.errors.join;
              } else {
                this.errors = MESSAGES['500'];
              }
            }
          }).catch((e) => {
            this.state.status = this.ModalStatus.Failure;
            if (MESSAGES.hasOwnProperty(e.status.toString())) {
              this.errors = MESSAGES[e.status.toString()];
            } else {
              this.errors = MESSAGES['500'];
            }
          });
        }
      },
      reset(e): void {
        this.state.status = this.ModalStatus.Confirmation;
        this.hideOrReturn(e);
      },
      goHome(e): void {
        window.location.assign("/");
      }
    }
  });

</script>